$.lui("comp",".comp_menu",function (selector) {
    let menu = selector.find("[data-lib-tabs-nav]");
    selector.on("click","[data-lib-tabs-item=\"nav\"]",function () {
        let el = $(this);
        menu.animate({
            scrollLeft: el.closest("li")[0].offsetLeft - 40
        },300);
    })
});